<template>
  <div>
    <v-app-bar
      :dark="isDark"
      height="150px"
      flat
      extended
      :src="images.banner || ''"
    >
      <v-row
        class="d-flex justify-space-between align-center mb-3"
        justify="space-between"
        align="center"
      >
        <v-col cols="2">
          <v-avatar size="40px">
            <v-img :src="images.logo" cover />
          </v-avatar>
        </v-col>
        <v-col cols="10" align="right">
          <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <template v-slot:img="{ props }">
        <v-img v-bind="props" aspect-ratio="2" :gradient="gradient"></v-img>
      </template>

      <template #extension>
        <v-tabs
          optional
          :dark="isDark"
          centered
          grow
          hide-slider
          :background-color="isDark ? '#1e1e1e' : 'white'"
          class="pt-7"
          :color="color"
        >
          <div v-for="category in categories" :key="category.id">
            <v-tab
              v-if="category.name != ''"
              :dark="isDark"
              :class="{
                'text--secondary': true,
                'grey--text': true,
                'text--darken-1': !isDark,
                'text--lighten-1': isDark
              }"
            >
              {{ category.name }}
            </v-tab>
          </div>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-list :dark="isDark" class="mt-2">
      <div
        v-for="category in categories"
        :key="category.id"
        flat
        class="overflow-y-auto mx-2"
        style="margin-bottom:60px; overflow-x:hidden !important;"
      >
        <div v-if="category.name" class="text-center my-2 text--secondary">
          <div
            :id="'select' + category.id"
            v-if="category.name != ''"
            :class="{
              headline: true,
              'grey--text': true,
              'text--darken-1': !isDark,
              'text--lighten-1': isDark,
              'text--secondary': true
            }"
          >
            {{ category.name }}
          </div>
          <hr />
        </div>

        <v-list-item
          v-for="product in category.products"
          :dark="isDark"
          :key="product.id"
        >
          <v-row :dark="isDark">
            <v-col cols="10">
              <div
                :class="{
                  'grey--text': true,
                  'text--darken-1': !isDark,
                  'text--lighten-1': isDark,
                  'body-1': true,
                  'text--secondary': true
                }"
              >
                {{ product.name }}
              </div>
              <div
                :class="{
                  'text--secondary': true,
                  caption: true,
                  'grey--text': true,
                  'text--darken-1': !isDark,
                  'text--lighten-1': isDark,
                  description: true
                }"
              >
                {{ product.description }}
              </div>
            </v-col>
            <v-col cols="2" class="text-right" align-self="start">
              <div class="d-flex flex-column align-center">
                <div class="body-2 m-0">
                  1.30€
                </div>
                <div class="d-flex justify-end text-center">
                  <v-icon
                    :color="color"
                    :dark="isDark"
                    class="d-flex justify-end text-center"
                  >
                    mdi-plus-circle-outline
                    <template />
                  </v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-list-item>
      </div>
    </v-list>

    <v-btn
      v-if="waiter"
      :color="color"
      fixed
      bottom
      right
      fab
      :dark="isButtonDark"
    >
      <v-icon>mdi-bell-outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ["color", "isDark", "images", "waiter"],
  computed: {
    gradient: function() {
      if (this.isDark) {
        return "to bottom, rgba(255, 255, 255, 0.0), #1e1e1e 84%";
      } else {
        return "to bottom, rgba(255, 255, 255, 0.0), white 92%";
      }
    },
    categories() {
      let categories = [];
      for (let i = 1; i < 5; i++) {
        let products = [];
        for (let j = 1; j < 4; j++) {
          products.push({
            id: `cat${i}prod${j}`,
            name: `${this.$t("Product")} ${j}`,
            description:
              "Lorem ipsum dolor sit amet, quis viris has eu, sea appellantur disputationi ei."
          });
        }
        categories.push({
          id: `cat${i}`,
          name: `${this.$t("Category")} ${i}`,
          products: products
        });
      }

      return categories;
    },
    isButtonDark() {
      let rgbStrings = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.color
      );
      let r = parseInt(rgbStrings[1], 16);
      let g = parseInt(rgbStrings[2], 16);
      let b = parseInt(rgbStrings[3], 16);
      return r * 0.299 + g * 0.587 + b * 0.114 <= 149;
    }
  }
};
</script>

<style scoped>
body::-webkit-scrollbar {
  display: none;
}
body {
  -ms-overflow-style: none;
  overflow: hidden;
}
.description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
